/* unplugin-vue-components disabled */import { ElRadioGroup as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadioButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/radio-button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode("国内");
const _hoisted_2 = /*#__PURE__*/_createTextVNode("国外");
import GlobalOrderList from './globalOrderList.vue';
import InternalOrderList from './internalOrderList.vue';
import InternalTicketVer from './internalTicketVer.vue';
import GlobalTicketVer from './globalTicketVer.vue';
import InternalRepairLog from './internal/repairLog.vue';
import GlobalRepairLog from './global/repairLog.vue';
import { useAppStore } from '@/store/modules/app';
import { disabledInternal } from '@/views/operate/hooks';
import IosMidst from '@/views/operate/lookup/orderSearch/iosMidst.vue';
export default /*#__PURE__*/_defineComponent({
  setup(__props, {
    expose
  }) {
    const isShowInternal = computed(() => {
      if (disabledInternal.includes(process.env.VUE_APP_PLAT)) {
        currentTable.value = 'global';
        return false;
      }
      return true;
    });
    const useApp = useAppStore();
    const gameInfo = computed(() => useApp.gameInfo);
    const internalTicketData = ref();
    const globalTicketData = ref();
    const currentTable = ref('internal');
    const tableKey = ref('internalTable');
    const active = ref('orderList');
    const panes = ref([{
      title: '订单列表',
      key: 'orderList',
      level: 0
    }, {
      title: '补单日志',
      key: 'repairLog',
      level: 1
    }, {
      title: '补单日志',
      key: 'globalRepairLog',
      level: 1
    }, {
      title: 'IOS玩家小票补单',
      key: 'iosMidst',
      level: 1
    }]);
    // 切换国内国外
    const handleChangeRadio = val => {
      if (val === 'internal') {
        tableKey.value = 'internalTable';
      }
      if (val === 'global') {
        tableKey.value = 'globalTable';
      }
    };
    const handleConfirm = () => {
      active.value = 'orderList';
    };
    const onActiveInternal = (type, data) => {
      if (data) internalTicketData.value = data;
      active.value = type;
    };
    const onActiveGlobal = (type, data) => {
      if (data) globalTicketData.value = data;
      active.value = type;
    };
    // 显示IOS小票补单
    const onIOSMidst = type => {
      console.log(type);
      active.value = 'iosMidst';
    };
    expose({
      handleConfirm
    });
    return (_ctx, _cache) => {
      const _component_el_radio_button = __unplugin_components_0;
      const _component_el_radio_group = __unplugin_components_1;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createBlock(_component_u_card, {
        modelValue: active.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => active.value = $event),
        panes: panes.value
      }, {
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "orderList"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: currentTable.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => currentTable.value = $event),
            style: {
              "margin-bottom": "30px"
            },
            onChange: handleChangeRadio
          }, {
            default: _withCtx(() => [_unref(isShowInternal) ? (_openBlock(), _createBlock(_component_el_radio_button, {
              key: 0,
              label: "internal"
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_radio_button, {
              label: "global"
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"]), currentTable.value === 'internal' && _unref(isShowInternal) ? (_openBlock(), _createBlock(InternalOrderList, {
            key: 0,
            gameInfo: _unref(gameInfo),
            tableKey: tableKey.value,
            onOnActive: onActiveInternal,
            onOnIOSMidst: onIOSMidst
          }, null, 8, ["gameInfo", "tableKey"])) : _createCommentVNode("", true), currentTable.value === 'global' ? (_openBlock(), _createBlock(GlobalOrderList, {
            key: 1,
            gameInfo: _unref(gameInfo),
            tableKey: tableKey.value,
            onOnActive: onActiveGlobal,
            onOnIOSMidst: onIOSMidst
          }, null, 8, ["gameInfo", "tableKey"])) : _createCommentVNode("", true)]),
          _: 1
        }), _unref(isShowInternal) ? (_openBlock(), _createBlock(InternalRepairLog, {
          key: 0,
          onOnActive: onActiveInternal
        })) : _createCommentVNode("", true), _createVNode(GlobalRepairLog, {
          gid: _unref(gameInfo).Id,
          onOnActive: onActiveGlobal
        }, null, 8, ["gid"]), _unref(isShowInternal) ? (_openBlock(), _createBlock(InternalTicketVer, {
          key: 1,
          internalTicketData: internalTicketData.value
        }, null, 8, ["internalTicketData"])) : _createCommentVNode("", true), _createVNode(GlobalTicketVer, {
          gameInfo: _unref(gameInfo),
          globalTicketData: globalTicketData.value
        }, null, 8, ["gameInfo", "globalTicketData"]), _createVNode(IosMidst)]),
        _: 1
      }, 8, ["modelValue", "panes"]);
    };
  }
});